import { useAthosContext } from '../fetchers/provider'
import { parseFilterList } from '../components/FilterUtils'

function stringifyOption(options, key) {
  const value = options.get(key)
  if (!value) return ''

  switch (key) {
    case 'filters':
      return [...value].join(',')
    default:
      return value
  }
}

function parseOption(params, key) {
  const value = params.get(key)
  if (!value) return ''

  switch (key) {
    case 'filters':
      return new Set(parseFilterList(value))
    case 'page': {
      const pageNum = parseInt(value)
      return isNaN(pageNum) ? '' : pageNum
    }
    default:
      return value
  }
}

function setParamsToURL(params) {
  const origin = window.location.origin
  const pathname = window.location.pathname
  let url = `${origin}${pathname}`
  if (params.size > 0) url += `?${params.toString()}`
  window.history.replaceState(window.history.state, '', url)
}

function getParamsFromURL() {
  return new URLSearchParams(window.location.search)
}

export function parseOptionFromURL(params, key) {
  return parseOption(params, key)
}

export function useOptionsSync() {
  const { refine, options, setOptions } = useAthosContext()

  function setOptionToURL(key) {
    const params = getParamsFromURL()
    const value = stringifyOption(options, key)
    if (value) params.set(key, value)
    else params.delete(key)
    setParamsToURL(params)
  }

  function getOptionFromURL(key) {
    const params = getParamsFromURL()
    const parsed = parseOption(params, key)
    if (parsed === '' || parsed === null || parsed === undefined) {
      refine(key, key === 'filters' ? new Set() : '')
      return
    }
    refine(key, parsed)
  }

  function setAllOptionsToURL() {
    const params = new URLSearchParams()
    for (const key of options.keys()) {
      params.set(key, stringifyOption(options, key))
    }
    setParamsToURL(params)
  }

  function getAllOptionsFromURL() {
    const params = getParamsFromURL()

    setOptions((prev) => {
      const next = new Map(prev)
      for (const key of params.keys()) {
        next.set(key, parseOption(params, key))
      }
      return next
    })
  }

  return {
    getOptionFromURL,
    setOptionToURL,
    getAllOptionsFromURL,
    setAllOptionsToURL
  }
}
